module.exports = __webpack_public_path__ + "img/poster_tem_2.604f8ac4.png";